<template>
	<section class="content checkout-content max-w-1120 wp_AllPageMarginTop">
		<div class="container">
			<div class="row m-0 mb-3">
				<div class="col-1"></div>
				<div class="col-10 p-3 mt-3 card dropshadow">
					<h4
						class="m-0"
						style="font-weight: 600;"
						id="checkout-payment-heading"
						data-test="paymentOptionHead"
					>
						Pay Using
					</h4>
					<hr>
					<!--<div class="d-block">-->
					<payment-gateway-selector/>
					<!--</div>-->
				</div>
				<div class="col-1"></div>
			</div>
		</div>
	</section>
</template>

<script>
import PaymentGatewaySelector from './checkout/widgets/PaymentGatewaySelector'

export default {
	components: {
		PaymentGatewaySelector
	},
	name: 'test'
}
</script>

<style scoped>

</style>
